import React from "react";

import { Icon } from "@stellar/design-system";

import { resolveInviteMessage } from "@/helpers/inviteMessageTemplate";

import { useRedux } from "@/hooks/useRedux";

import "./styles.scss";

interface DisbursementSmsPreviewProps {
  orgName: string;
  walletName: string;
  language: string;
  customSmsTemplate: string;
}

const PLACEHOLDER_LINK = "https://example.org/register";

export const DisbursementSmsPreview: React.FC<DisbursementSmsPreviewProps> = ({
  orgName,
  walletName,
  language,
  customSmsTemplate,
}: DisbursementSmsPreviewProps) => {
  const { organization } = useRedux("organization");

  const template = resolveInviteMessage({
    organizationMessage: customSmsTemplate,
    language,
    walletName,
    languageTemplates: organization.data.receiverInvitationMessageTemplates,
  });

  const renderedMessage = template
    .replace(/\{\{\.OrganizationName\}\}/g, orgName || "Your Organization")
    .replace(/\{\{\.RegistrationLink\}\}/g, PLACEHOLDER_LINK);

  return (
    <div className="DisbursementSmsPreview">
      <p className="DisbursementSmsPreview__label">
        This preview reflects the SMS message receivers will get.
      </p>

      <div className="DisbursementSmsPreview__phone">
        {/* Phone status bar */}
        <div className="DisbursementSmsPreview__statusBar">
          <span className="DisbursementSmsPreview__time">9:00</span>
        </div>

        {/* Message header */}
        <div className="DisbursementSmsPreview__header">
          <Icon.ChevronLeft />
          <div className="DisbursementSmsPreview__headerInfo">
            <div className="DisbursementSmsPreview__headerAvatar">
              <Icon.Phone01 />
            </div>
            <span className="DisbursementSmsPreview__headerName">
              {orgName || "Your Organization"}
            </span>
          </div>
        </div>

        {/* Message bubble */}
        <div className="DisbursementSmsPreview__messages">
          <div className="DisbursementSmsPreview__bubble">
            <p className="DisbursementSmsPreview__bubbleText">{renderedMessage}</p>
            <span className="DisbursementSmsPreview__bubbleTime">Today, 9:00 AM</span>
          </div>
        </div>
      </div>
    </div>
  );
};
